// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__PlO-i","label":"Section_label__2lumm","contentWrap":"Section_contentWrap__15kxb","footer":"Section_footer__3pdwi","footerInner":"Section_footerInner__KEeUW"};